import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { loadProfile, loadSupportMessages, getCachedProfile, setCachedProfile } from "../utils/Network";
import { getDefaultValue, logout } from "../utils";
import { useStateValue } from "../StateProvider";
import HelpModal from "../components/dialogs/HelpModal";
import PageHeaderLight from "../components/shared/PageHeaderLight";
import DashboardHeaderProfileWidget from "../components/widgets/DashboardHeaderProfileWidget";
import FaqsContent from "./FaqsContent";
import "./Dashboard.css";

function formatSupportDate(iso) {
  if (!iso) return "";
  const normalized = String(iso).replace(" ", "T").replace("Z", "");
  const d = new Date(normalized);
  if (Number.isNaN(d.getTime())) {
    return String(iso).replace("T", " ").replace("Z", "");
  }
  return d.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

export default function Message() {
  const [messages, setMessages] = useState(null);
  const [profile, setProfile] = useState(() => getCachedProfile());
  const [activeTab, setActiveTab] = useState("faq");

  const [{ translations }] = useStateValue();
  const translate = (str) => {
    if (!translations) return str;
    var translate = translations.find((x) => x.key == str);

    if (translate) return getDefaultValue(translate);
    else return str;
  };

  useEffect(() => {
    loadProfile().then((data) => {
      if (data) {
        setProfile(data);
      } else {
        logout();
        window.location.href = "signin";
      }
    });
  }, []);

  useEffect(() => {
    loadSupportMessages().then((list) => {
      setMessages(Array.isArray(list) ? list : []);
    });
  }, []);

  const list = messages;

  return (
    <div className="participant-dashboard">
      <div role="main" className="main page-background">
        <PageHeaderLight />
        <div className="container participant-dashboard__container pt-3 pb-5">
          <div className="row pt-2  align-items-start participant-dashboard__row">
            <div className="col-12 participant-dashboard__main participant-support-page">
              <header className="participant-dashboard__header">
                <div className="participant-dashboard__header-inner">
                  <DashboardHeaderProfileWidget
                    profile={profile}
                    onProfileUpdated={(p) => {
                      setProfile(p);
                      setCachedProfile(p);
                    }}
                  />
                </div>
              </header>
              <div className="participant-dashboard__header-copy lan-text-right">
                <p className="participant-dashboard__subtitle mb-0">
                  {translate(
                    "Explore frequently asked questions or create a new ticket"
                  )}
                </p>
              </div>

              <div
                className="participant-support-page__tabs lan-kfont lan-text-right lan-rtl"
                role="tablist"
                aria-label={translate("Support")}
              >
                <button
                  type="button"
                  role="tab"
                  id="support-tab-faq"
                  aria-selected={activeTab === "faq"}
                  aria-controls="support-tabpanel-faq"
                  className={`participant-support-page__tab participant-support-page__action lan-kfont ${
                    activeTab === "faq"
                      ? "participant-support-page__action--accent"
                      : "participant-support-page__action--ghost"
                  }`}
                  onClick={() => setActiveTab("faq")}
                >
                  <i className="far fa-question-circle" aria-hidden />
                  <span>{translate("FAQ")}</span>
                </button>
                <button
                  type="button"
                  role="tab"
                  id="support-tab-tickets"
                  aria-selected={activeTab === "tickets"}
                  aria-controls="support-tabpanel-tickets"
                  className={`participant-support-page__tab participant-support-page__action lan-kfont ${
                    activeTab === "tickets"
                      ? "participant-support-page__action--accent"
                      : "participant-support-page__action--ghost"
                  }`}
                  onClick={() => setActiveTab("tickets")}
                >
                  <i className="far fa-comments" aria-hidden />
                  <span>{translate("Tickets")}</span>
                </button>
              </div>

              {activeTab === "tickets" && (
                <div
                  id="support-tabpanel-tickets"
                  role="tabpanel"
                  aria-labelledby="support-tab-tickets"
                >
                  <div className="participant-support-page__new-ticket lan-kfont lan-text-right lan-rtl mb-3">
                    <a
                      href="#help"
                      className="participant-support-page__action participant-support-page__action--accent lan-kfont"
                      data-toggle="modal"
                      data-target="#helpModal"
                    >
                      <i className="far fa-edit" aria-hidden />
                      <span>{translate("New Ticket")}</span>
                    </a>
                  </div>

                  <div
                    className="participant-support-page__list lan-kfont lan-text-right lan-rtl"
                    role="list"
                  >
                    {list === null && (
                      <p className="participant-support-page__hint lan-text-right lan-rtl mb-0">
                        {translate("Please wait")}…
                      </p>
                    )}
                    {list &&
                      list.map((message) => (
                        <Link
                          key={message.id}
                          to={`/support/${message.id}`}
                          className="participant-support-page__card kfont"
                          role="listitem"
                        >
                          <div className="participant-support-page__card-body">
                            <h2 className="participant-support-page__card-title lan-text-right mb-0">
                              {message.title}
                            </h2>
                            <time
                              className="participant-support-page__card-meta"
                              dateTime={message.updated_at}
                            >
                              {formatSupportDate(message.updated_at)}
                            </time>
                          </div>
                          <span
                            className="participant-support-page__card-chev"
                            aria-hidden
                          >
                            <i className="fas fa-angle-right participant-support-page__card-chev-icon" />
                          </span>
                        </Link>
                      ))}
                  </div>
                </div>
              )}

              {activeTab === "faq" && <FaqsContent embedded />}
            </div>
          </div>
        </div>
      </div>
      <HelpModal />
    </div>
  );
}
